import React, { useState, useEffect, useCallback } from 'react';
import { ref, onValue, set } from 'firebase/database';
import { database } from './firebase';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import FlipNumbers from 'react-flip-numbers';
import './CountPage.css';

const CountPage = () => {
  const [startTime, setStartTime] = useState(null);
  const [elapsed, setElapsed] = useState(0);
  const location = useLocation();

  useEffect(() => {
    const startTimeRef = ref(database, 'startTime');
    onValue(startTimeRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setStartTime(data);
      } else {
        // Initialize if not set
        set(startTimeRef, Date.now());
      }
    });
  }, []);

  useEffect(() => {
    if (startTime) {
      const interval = setInterval(() => {
        setElapsed(Date.now() - startTime);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [startTime]);

  const handleReset = useCallback(() => {
    const newStartTime = Date.now();
    set(ref(database, 'startTime'), newStartTime);
    setStartTime(newStartTime);
    setElapsed(0);
  }, []);

  useEffect(() => {
    if (location.pathname === '/reset' && startTime) {
      handleReset();
    }
  }, [location.pathname, startTime, handleReset]);

  const formatTime = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return {
      days: days.toString().padStart(2, '0'),
      hours: hours.toString().padStart(2, '0'),
      minutes: minutes.toString().padStart(2, '0'),
      seconds: seconds.toString().padStart(2, '0')
    };
  };

  return (
    <div className="CountPage">
      <Header />
      <div className="counter-container">
        <h1>Count since last joke</h1>
        <div className="timer">
          <div className="time-unit">
            <div className="label">Days</div>
            <FlipNumbers
              height={60}
              width={40}
              color="#333"
              background="#e9ecef"
              play
              perspective={1000}
              numbers={formatTime(elapsed).days}
            />
          </div>
          <div className="separator">:</div>
          <div className="time-unit">
            <div className="label">Hours</div>
            <FlipNumbers
              height={60}
              width={40}
              color="#333"
              background="#e9ecef"
              play
              perspective={1000}
              numbers={formatTime(elapsed).hours}
            />
          </div>
          <div className="separator">:</div>
          <div className="time-unit">
            <div className="label">Minutes</div>
            <FlipNumbers
              height={60}
              width={40}
              color="#333"
              background="#e9ecef"
              play
              perspective={1000}
              numbers={formatTime(elapsed).minutes}
            />
          </div>
          <div className="separator">:</div>
          <div className="time-unit">
            <div className="label">Seconds</div>
            <FlipNumbers
              height={60}
              width={40}
              color="#333"
              background="#e9ecef"
              play
              perspective={1000}
              numbers={formatTime(elapsed).seconds}
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CountPage;
